import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见问题</h2>
            <p className="text-sm text-foreground-500 mt-1">关于古古漫画网的常见疑问解答</p>
          </div>
          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq, index) => (
              <details
                key={index}
                className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
              >
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100/50 transition-colors select-none">
                  <span className="font-medium text-sm md:text-base text-foreground-800 pr-4">{faq.question}</span>
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform shrink-0 w-4 h-4 flex items-center justify-center"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}